export default __webpack_public_path__ + "static/odyssey_zoom_bg-48da16c1af4363a4c5996c4cb02f4ecb.png";